import { html, css } from 'lit';
import { customElement } from 'lit/decorators.js';
import { ItemBadge } from '../../server/types.js';
import WarpElement from '@warp-ds/elements-core';
import '@warp-ds/components/icon';

@customElement('recommendation-badge')
export class RecommendationBadge extends WarpElement {
	static styles = [
		...WarpElement.styles,
		css`
			:host {
				display: block;
			}
			/** The line below is where the injected CSS goes, removing it means you get no CSS from the design system **/
			*,:before,:after{--w-rotate:0;--w-rotate-x:0;--w-rotate-y:0;--w-rotate-z:0;--w-scale-x:1;--w-scale-y:1;--w-scale-z:1;--w-skew-x:0;--w-skew-y:0;--w-translate-x:0;--w-translate-y:0;--w-translate-z:0}.static{position:static}.mr-4{margin-right:.4rem};
		`,
	];

	badge?: ItemBadge;

	static properties = {
		badge: { type: Object },
		locale: { type: String }
	};

	mapBadgeStyleToVariant(style: ItemBadge['style'] | undefined): 'sponsored' | 'positive' | 'warning' | 'info' {
		const styleMap = {
			sponsored: 'sponsored',
			success: 'positive',
			warning: 'warning',
			default: 'info',
		} as const;

		if (!style || !(style in styleMap)) {
			return 'info';
		}

		return styleMap[style];
	}

	getIcon(icon: string | undefined) {
		if (icon === undefined) {
			return '';
		}

		switch (icon) {
			case 'external':
				return html`<w-icon name="LinkExternal" size="small" locale="${this.locale}" class="flex mr-4"></w-icon>`;
			case 'shipping':
				return html`<w-icon name="Shipping" size="small" locale="${this.locale}" class="flex mr-4"></w-icon>`;
			default:
				return '';
		}
	}

	render() {
		if (!this.badge || !this.badge.label) return html``;

		const variant = this.mapBadgeStyleToVariant(this.badge.style);
		return html`
			<w-badge variant="${variant}" position="top-left"> ${this.getIcon(this.badge.icon)} ${this.badge.label} </w-badge>
		`;
	}
}
